/**
 * Devices
 * Devices
 *
 * The version of the OpenAPI document: 1.0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 0 = Terms, 1 = DateHistogram, 2 = Range, 3 = Stats, 4 = Min, 5 = Max, 6 = Avg, 7 = Sum, 8 = Count, 9 = Cardinality
 */
export enum AggregationType {
    Terms = 'terms',
    DateHistogram = 'datehistogram',
    Range = 'range',
    Stats = 'stats',
    Min = 'min',
    Max = 'max',
    Avg = 'avg',
    Sum = 'sum',
    Count = 'count',
    Cardinality = 'cardinality'
}

